import "./ColorInput.scss";
import classNames from "classnames";
import {useEffect, useRef, useState} from "react";
import {HexColorInput, HexColorPicker} from "react-colorful";

const DEFAULT_COLOR = "#FF5733";

const clamp = (v) => {
    return Math.max(0, Math.min(255, v));
}

const hexToRgb = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return {
        r: Number.isNaN(r) ? 0 : r,
        g: Number.isNaN(g) ? 0 : g,
        b: Number.isNaN(b) ? 0 : b,
    };
}

const rgbToHex = (r, g, b) => {
    return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
}

const ColorInput = ({formik, name, value, onChange, error, readOnly}) => {
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef(null);
    const buttonRef = useRef(null);

    const currentValue = formik ? formik.values[name] : value;
    const color = currentValue || DEFAULT_COLOR;
    const rgb = hexToRgb(color);

    const setColor = (value) => {
        if (formik) {
            formik.setFieldValue(name, value);
        }

        onChange?.(value);
    }

    const handleRgbChange = (e) => {
        const {name: channel, value} = e.target;
        const next = {...rgb, [channel]: clamp(Number(value))};
        setColor(rgbToHex(next.r, next.g, next.b));
    }

    const handleClickOutside = (e) => {
        if (modalRef.current && buttonRef.current && !modalRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
            setShowModal(false);
        }
    }

    useEffect(() => {
        if (formik && !currentValue) {
            setColor(DEFAULT_COLOR);
        }
    }, [currentValue]);

    useEffect(() => {
        if (showModal) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showModal]);

    return <div className="color-input">
        <button
            ref={buttonRef}
            id={name}
            type="button"
            className={classNames("color-preview", {"wrong-input": error})}
            disabled={readOnly}
            onClick={() => setShowModal(prev => !prev)}
        >
            <span className="color" style={{backgroundColor: color}}></span>
            <span className="hex">{color.toUpperCase()}</span>
        </button>

        {showModal && <div ref={modalRef} className="color-popover">
            <HexColorPicker color={color} onChange={setColor}/>

            <div className="inputs">
                <HexColorInput
                    color={color}
                    onChange={setColor}
                    prefixed={true}
                />
                <input type="number" name="r" min={0} max={255} value={rgb.r} onChange={handleRgbChange}/>
                <input type="number" name="g" min={0} max={255} value={rgb.g} onChange={handleRgbChange}/>
                <input type="number" name="b" min={0} max={255} value={rgb.b} onChange={handleRgbChange}/>

                <span>Hex</span>
                <span>R</span>
                <span>G</span>
                <span>B</span>
            </div>
        </div>}
    </div>
}

export default ColorInput
